// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.body_a2glT {
  font-family: 'Arial', sans-serif;
  margin: 20px;
  padding: 10px;
  background-color: #fff;
  width: 25cm;
  height: 29.7cm;
  margin-bottom: 30px;
}
.printableContent_fnW2m {
  display: block;
  margin: 0 auto;
  margin-bottom: 0.5cm;
}
.col_sm_V6x5y {
  width: 100%;
}
.hedertext_LOez4 {
  padding: 0 64px;
}
.hedertextCompanyName_hMlOO {
  font-size: 27px;
  color: #2961af;
  display: inline-block;
  margin: 0;
}
.headersmalltext_DMTda {
  display: inline;
  margin: 0;
  font-size: 16px;
  color: #969997;
}
.headerlogo_i3VcU {
  float: right;
  width: 150px;
  height: 80px;
  top: 0;
  position: static;
  object-fit: contain;
}
.headerContainer_UsZRD {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.title_E1bUF {
  font-size: 37px;
  color: #2961af;
  font-weight: 700;
}
.text1_D1Cye {
  font-size: 20px !important ;
}
.tabletext_fLuWK {
  width: '100%';
  margin-top: 20px;
  border-collapse: collapse;
}
.tableTrborder_nCPaJ {
  border-bottom: 1px solid #ccc;
  text-align: justify;
}
.th1_SLak_ {
  width: 20%;
}
.th2_lLRf8 {
  width: 35%;
}
.th3_zQaLo {
  width: 10%;
}
.th4_jW7hw {
  width: 15%;
}
.th5_d1OlX {
  width: 15%;
}
.th6_eWJuO {
  width: 20%;
}
.thService_TyTqg {
  margin-left: 40px !important;
}
.trbrorder_nSbsV {
  border-bottom: 1px solid #ccc;
  text-align: justify;
}
.tdstyle_FwaHN {
  padding-left: 30px;
  padding-right: 30px;
}
.tableBottomtext_JoxsH {
  margin-top: 20px;
  font-size: 18px;
  position: relative;
  left: 62%;
  margin-bottom: 20px;
  right: 0;
}
.footer_U3QXW {
  margin-top: 180px;
  color: #969997;
}
.button_jFBVY {
  margin-top: 30px;
}
@media print {
  body,
  div[data-size='A4'] {
    margin: 0;
    box-shadow: 0;
  }
}
`, "",{"version":3,"sources":["webpack://./src/Pages/Invoice/Invoicing/CommunicationStatus/preview.less"],"names":[],"mappings":"AAAA;EACI,gCAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;EACA,WAAA;EACA,cAAA;EACA,mBAAA;AACJ;AACA;EACI,cAAA;EACA,cAAA;EACA,oBAAA;AACJ;AACA;EACI,WAAA;AACJ;AAEA;EACI,eAAA;AAAJ;AAEA;EACI,eAAA;EACA,cAAA;EACA,qBAAA;EACA,SAAA;AAAJ;AAEA;EACI,eAAA;EACA,SAAA;EACA,eAAA;EACA,cAAA;AAAJ;AAEA;EACI,YAAA;EACA,YAAA;EACA,YAAA;EACA,MAAA;EACA,gBAAA;EACA,mBAAA;AAAJ;AAEA;EACI,aAAA;EACA,8BAAA;EACA,mBAAA;AAAJ;AAGA;EACI,eAAA;EACA,cAAA;EACA,gBAAA;AADJ;AAGA;EACI,2BAAA;AADJ;AAGA;EACI,aAAA;EACA,gBAAA;EACA,yBAAA;AADJ;AAGA;EACI,6BAAA;EACA,mBAAA;AADJ;AAGA;EACI,UAAA;AADJ;AAGA;EACI,UAAA;AADJ;AAGA;EACI,UAAA;AADJ;AAGA;EACI,UAAA;AADJ;AAGA;EACI,UAAA;AADJ;AAGA;EACI,UAAA;AADJ;AAGA;EACI,4BAAA;AADJ;AAGA;EACI,6BAAA;EACA,mBAAA;AADJ;AAGA;EACI,kBAAA;EAEA,mBAAA;AAFJ;AAIA;EACI,gBAAA;EACA,eAAA;EACA,kBAAA;EACA,SAAA;EACA,mBAAA;EACA,QAAA;AAFJ;AAIA;EACI,iBAAA;EACA,cAAA;AAFJ;AAIA;EACI,gBAAA;AAFJ;AAIA;EACI;;IAEI,SAAA;IACA,aAAA;EAFN;AACF","sourcesContent":[".body {\n    font-family: 'Arial', sans-serif;\n    margin: 20px;\n    padding: 10px;\n    background-color: #fff;\n    width: 25cm;\n    height: 29.7cm;\n    margin-bottom: 30px;\n}\n.printableContent {\n    display: block;\n    margin: 0 auto;\n    margin-bottom: 0.5cm;\n}\n.col_sm {\n    width: 100%;\n}\n\n.hedertext {\n    padding: 0 64px;\n}\n.hedertextCompanyName {\n    font-size: 27px;\n    color: #2961af;\n    display: inline-block;\n    margin: 0;\n}\n.headersmalltext {\n    display: inline;\n    margin: 0;\n    font-size: 16px;\n    color: #969997;\n}\n.headerlogo {\n    float: right;\n    width: 150px;\n    height: 80px;\n    top: 0;\n    position: static;\n    object-fit: contain;\n}\n.headerContainer {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n}\n\n.title {\n    font-size: 37px;\n    color: #2961af;\n    font-weight: 700;\n}\n.text1 {\n    font-size: 20px !important ;\n}\n.tabletext {\n    width: '100%';\n    margin-top: 20px;\n    border-collapse: collapse;\n}\n.tableTrborder {\n    border-bottom: 1px solid #ccc;\n    text-align: justify;\n}\n.th1 {\n    width: 20%;\n}\n.th2 {\n    width: 35%;\n}\n.th3 {\n    width: 10%;\n}\n.th4 {\n    width: 15%;\n}\n.th5 {\n    width: 15%;\n}\n.th6 {\n    width: 20%;\n}\n.thService {\n    margin-left: 40px !important;\n}\n.trbrorder {\n    border-bottom: 1px solid #ccc;\n    text-align: justify;\n}\n.tdstyle {\n    padding-left: 30px;\n\n    padding-right: 30px;\n}\n.tableBottomtext {\n    margin-top: 20px;\n    font-size: 18px;\n    position: relative;\n    left: 62%;\n    margin-bottom: 20px;\n    right: 0;\n}\n.footer {\n    margin-top: 180px;\n    color: #969997;\n}\n.button {\n    margin-top: 30px;\n}\n@media print {\n    body,\n    div[data-size='A4'] {\n        margin: 0;\n        box-shadow: 0;\n    }\n}\n\n@primary-color: #2FB153;@link-color: #1DA57A;@border-radius-base: 2px;"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"body": `body_a2glT`,
	"printableContent": `printableContent_fnW2m`,
	"col_sm": `col_sm_V6x5y`,
	"hedertext": `hedertext_LOez4`,
	"hedertextCompanyName": `hedertextCompanyName_hMlOO`,
	"headersmalltext": `headersmalltext_DMTda`,
	"headerlogo": `headerlogo_i3VcU`,
	"headerContainer": `headerContainer_UsZRD`,
	"title": `title_E1bUF`,
	"text1": `text1_D1Cye`,
	"tabletext": `tabletext_fLuWK`,
	"tableTrborder": `tableTrborder_nCPaJ`,
	"th1": `th1_SLak_`,
	"th2": `th2_lLRf8`,
	"th3": `th3_zQaLo`,
	"th4": `th4_jW7hw`,
	"th5": `th5_d1OlX`,
	"th6": `th6_eWJuO`,
	"thService": `thService_TyTqg`,
	"trbrorder": `trbrorder_nSbsV`,
	"tdstyle": `tdstyle_FwaHN`,
	"tableBottomtext": `tableBottomtext_JoxsH`,
	"footer": `footer_U3QXW`,
	"button": `button_jFBVY`
};
export default ___CSS_LOADER_EXPORT___;
